import { client, IRootState } from '..';
import { Module } from 'vuex';
import { ILabor, IProject, IProjectLaborType } from '@/models';

interface IState {
  projects: IProject[];
  laborTypes: Record<string, IProjectLaborType>;
}

export const labor: Module<IState, IRootState> = {
  namespaced: true,
  state: {
    projects: [],
    laborTypes: {},
  },
  actions: {
    getLaborByUser({ commit }, userId) {
      return client
        .get(`labor/project/user/${userId}`)
        .then(({ data }) => commit('setEntities', data));
    },
    getLaborTypes({ commit }) {
      return client.get('project_labor_type/all').then(({data}) => commit('setLaborTypes', data))
    },
    createLabor({commit}, entity: ILabor) {
      return client.post('labor', entity);
    }
  },
  mutations: {
    setEntities(state, projects) {
      state.projects = projects;
    },
    setLaborTypes(state, laborTypes: IProjectLaborType[]) {
      state.laborTypes = laborTypes.reduce((acc, item) => {
        acc[item.id] = item;
        return acc;
      }, {} as Record<string, IProjectLaborType>);
    }
  },
  getters: {},
};
